export enum AnnouncementComponent {
  ADMIN_VIEW = '',
  LOQ_ANNOUNCEMENT = 'LoqAnnouncement',
  ORGANIZATION_ANNOUNCEMENT = 'OrganizationAnnouncement',
}
